import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Translation } from '../components/Translation';
const useInputLabelDisplay = (label) => {
    return useMemo(() => {
        if (label?.startsWith('trans__')) {
            return _jsx(Translation, { id: label }, label);
        }
        return label;
    }, [label]);
};
export default useInputLabelDisplay;
//# sourceMappingURL=useInputLabelDisplay.js.map